/**
 * GTM Event Tracking Utility
 * 
 * Provides helper functions for pushing events to dataLayer for Google Tag Manager tracking.
 */

/**
 * Push event to dataLayer for GTM tracking
 * 
 * @param {string} eventName Event name (e.g., 'lease_request_started')
 * @param {Object} eventData Optional additional event data
 */
export function trackEvent( eventName, eventData = {} ) {
	if ( typeof window === 'undefined' || typeof window.dataLayer === 'undefined' ) {
		// Initialize dataLayer if it doesn't exist
		window.dataLayer = window.dataLayer || [];
	}

	if ( ! eventName || typeof eventName !== 'string' ) {
		console.warn( '[GTM Tracking] Event name must be a non-empty string' );
		return;
	}

	const eventPayload = {
		event: eventName,
		...eventData,
	};

	window.dataLayer.push( eventPayload );
}

/**
 * Track form request started event
 * 
 * @param {string} requestType Type of request ('lease', 'buy', 'contact', 'trial_ride', 'offerte')
 * @param {Object} additionalData Optional additional data (e.g., { car_id: 123 })
 */
export function trackRequestStarted( requestType, additionalData = {} ) {
	const eventName = `${ requestType }_request_started`;
	trackEvent( eventName, additionalData );
}

/**
 * Track form request completed event
 * 
 * @param {string} requestType Type of request ('lease', 'buy', 'contact', 'trial_ride', 'offerte')
 * @param {Object} additionalData Optional additional data (e.g., { car_id: 123 })
 */
export function trackRequestCompleted( requestType, additionalData = {} ) {
	const eventName = `${ requestType }_request_completed`;
	trackEvent( eventName, additionalData );
}
